module.exports = __webpack_public_path__ + "img/login-team-banner.cdc15add.png";